import BaseService from "../baseService";
class CentroCustoEmpresa extends BaseService {
  constructor(id) {
    const resource = "nfe-ncm/centro-custo-empresa";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new CentroCustoEmpresa(id);
